import { FormControl, FormLabel, Input, FormErrorMessage, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const FlagFallInRateField = ({ value, onChange, error }) => {
  const labelColor = useColorModeValue('black', 'white');
  const inputBg = useColorModeValue('white', '#23272F');
  const inputColor = useColorModeValue('black', 'white');
  const borderColor = useColorModeValue('gray.200', '#444950');
  const { darkMode } = useSelector((state) => state.settings);
  return (
    <FormControl isInvalid={!!error} isRequired>
      <FormLabel color={darkMode ? 'white' : 'black'}>Flag Fall In Rate</FormLabel>
      <Input
        name="flagFallInRate"
        value={value}
        onChange={onChange}
        placeholder="Flag Fall In Rate"
        type="number"
        step="0.000001"
        style={{
          background: darkMode ? '#1e2021' : 'white',
      color: `${darkMode ? '#f5f4f3' : 'inherit'}`,
          borderColor: `${darkMode ? '#565557' : '#007bff'}`
        }}

      />
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default FlagFallInRateField;
